import React from 'react';
import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbPortal } from '@/components/Header';
import { buildRoutePath } from '@/utils/routes';

import { CaseDetailsRouter } from './details/CaseDetailsRouter';

/**
 * CaseDetailsPage - Main entry point for case details routes
 *
 * This component:
 * 1. Validates the caseId from route params
 * 2. Delegates to CaseDetailsRouter which selects the appropriate workflow-specific page
 *
 * The router pattern allows different workflows to have completely different page implementations.
 */
export const CaseDetailsPage: React.FC = () => {
  const { caseId, orgId, progId } = useParams<{
    caseId?: string;
    orgId?: string;
    progId?: string;
  }>();

  // If no caseId, show error
  if (!caseId) {
    return (
      <>
        <BreadcrumbPortal>
          <Breadcrumb>
            <Breadcrumb.Item to={buildRoutePath('/cases', orgId || '', progId || '')}>
              Cases
            </Breadcrumb.Item>
            <Breadcrumb.Item>Invalid Case</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbPortal>
        <div className="flex flex-col justify-center items-center h-full">
          <p className="text-muted-foreground">Invalid case ID</p>
        </div>
      </>
    );
  }

  return <CaseDetailsRouter caseId={caseId} orgId={orgId} progId={progId} />;
};
